<template>
  <div class="onlineList">
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 赛事名称input -->
        <el-form-item :label="$t('lang.lab_competeName')">
          <input style="display: none"/>
          <el-input v-model="name" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeName')"></el-input>
        </el-form-item>
        <!-- 状态select -->
        <el-form-item :label="$t('lang.lab_competeStatus')">
          <el-select v-model="state" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeStatus')">
            <el-option
              v-for="(item,index) in states"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 赛事名称 -->
        <el-table-column prop="name" :label="$t('lang.lab_competeName')" :sortable="'custom'" width="300"></el-table-column>
        <!-- 状态 -->
        <el-table-column prop="competeStatusName" :label="$t('lang.lab_competeStatus')" :sortable="'custom'"></el-table-column>
        <!-- 已报人次 -->
        <el-table-column prop="enrollNum" :label="$t('lang.lab_enrollNum')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-link type="primary" @click="linkPlayer(scope.row)">{{ scope.row.enrollNum }}</el-link>
          </template>
        </el-table-column>
        <!-- 累计收费(元) -->
        <el-table-column prop="totalFee" :label="$t('lang.lab_totalFee')" :sortable="'custom'"></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operationn" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
            <el-button @click="onDetail(scope.row)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑查看 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="880px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="180px" label-suffix=":">
        <!-- 赛事名称 -->
        <el-form-item prop="name" :label="$t('lang.lab_competeName')">
          <input style="display: none"/>
          <el-input v-model="form.name" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeName')" maxlength="20" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 状态 -->
        <el-form-item prop="competeStatus" :label="$t('lang.lab_competeStatus')" v-if="isCase === 0">
          <el-select v-model="form.competeStatus" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeStatus')" :disabled="isCase === 2">
            <el-option
              v-for="(item,index) in statesNew"
              :key="index"
              :value="item.id"
              :label="item.name"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="competeStatus" :label="$t('lang.lab_competeStatus')" v-if="isCase !== 0">
          <el-select v-model="form.competeStatus" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeStatus')" :disabled="isCase === 2">
            <el-option
              v-for="(item,index) in statesEdit"
              :key="index"
              :value="item.id"
              :label="item.name"
              :disabled="item.disabled">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 报名时间 -->
        <el-form-item prop="enrollTime" :label="$t('lang.lab_enrollTime')">
          <el-date-picker
            v-model="enrollValues"
            type="datetimerange"
            :clearable="false"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_enrollTimeStart')"
            :end-placeholder="$t('lang.lab_enrollTimeEnd')"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            :disabled="isCase === 2"
            :picker-options="pickerOptions0"
            @change="onPickEnroll"
          ></el-date-picker>
        </el-form-item>
        <!-- 比赛时间 -->
        <el-form-item prop="raceTime" :label="$t('lang.lab_raceTime')">
          <el-date-picker
            v-model="raceValues"
            type="datetimerange"
            :clearable="false"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_raceTimeStart')"
            :end-placeholder="$t('lang.lab_raceTimeEnd')"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            :disabled="isCase === 2"
            :picker-options="pickerOptions1"
            @change="onPickRace"
          ></el-date-picker>
        </el-form-item>
        <!-- 报名上限 -->
        <el-form-item prop="enrollLimit" :label="$t('lang.lab_enrollLimit')">
          <input style="display: none"/>
          <el-input v-model="form.enrollLimit" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_enrollLimit')" maxlength="5" @input="keyEnrollLimit" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 年龄段限制 -->
        <el-form-item prop="itemAgeId" :label="$t('lang.lab_itemAgeId')" >
          <el-select v-model="form.itemAgeId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_itemAgeId')" :disabled="isCase === 2">
            <el-option
              v-for="(item,index) in ageNames"
              :key="index"
              :value="item.id"
              :label="item.ageGroupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年龄判断基准 -->
        <el-form-item prop="ageStandard" :label="$t('lang.lab_ageStandard')">
          <el-date-picker 
          :disabled="isCase === 2"
           v-model="form.ageStandard"
           type="date"
           value-format="timestamp"
           placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <!-- 组别限制 -->
        <el-form-item prop="itemGroupId" :label="$t('lang.lab_itemGroupId')" >
          <el-select v-model="form.itemGroupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_itemGroupId')" :disabled="isCase === 2">
            <el-option
              v-for="(item,index) in groupNames"
              :key="index"
              :value="item.id"
              :label="item.groupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 参赛作品时长限制 -->
        <el-form-item prop="videoTimeLimit" :label="$t('lang.lab_videoTimeLimit')">
          <el-row>
            <el-col :span="10"><input style="display: none"/><el-input v-model="form.videoTimeLowLimit" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_videoTimeLowLimit')" maxlength="3" @input="keyTimeLow" :disabled="isCase === 2"></el-input></el-col>
            <el-col :span="4"><div class="center-style"><span>——</span></div></el-col>
            <el-col :span="10"><input style="display: none"/><el-input v-model="form.videoTimeUpLimit" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_videoTimeUpLimit')" maxlength="3" @input="keyTimeHigh" :disabled="isCase === 2"></el-input></el-col>
          </el-row>
        </el-form-item>
        <!-- 单人单项费用 -->
        <el-form-item prop="singleFee" :label="$t('lang.lab_singleFee')">
          <input style="display: none"/>
          <el-input v-model="form.singleFee" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_singleFee1')" maxlength="7" @input="keySingleFee" :disabled="isCase === 2"></el-input>
        </el-form-item>
        <!-- 投票限制 -->
        <el-row>
          <!-- 投票限制 -->
          <el-col :span="12">
            <el-form-item prop="voteLimit" :label="$t('lang.lab_voteLimit')">
              <el-select v-model="form.voteLimit" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_voteLimit')" @change="changeSelect(form.voteLimit)" :disabled="isCase === 2">
                <el-option
                  v-for="(item,index) in voteLimits"
                  :key="index"
                  :value="item.id"
                  :label="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 每日可投票数 -->
          <el-col :span="12">
            <el-form-item prop="voteNum" :label="$t('lang.lab_voteNum')" v-if="form.voteLimit === 1">
              <input style="display: none"/>
              <el-input v-model="form.voteNum" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_voteNum')" maxlength="2" @input="keyLimitNum" :disabled="isCase === 2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 评分规则 -->
        <el-form-item prop="pointRule" :label="$t('lang.lab_pointRule')">
          <el-row>
            <!-- 人气分 -->
            <el-col :span="8">
              <div class="pointRule-position">
                <span class="popularPoint-style">{{$t('lang.lab_popularPoint1')}}</span>
                <el-input v-model="form.popularPoint" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_popularPoint')" maxlength="5" @input="keyPPoint" :disabled="isCase === 2"></el-input>
              </div>
            </el-col>
            <!-- 专家分 -->
            <el-col :span="8">
              <div class="pointRule-position">
                <span class="technicalPoint-style">{{$t('lang.lab_technicalPoint1')}}</span>
                <el-input v-model="form.technicalPoint" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_technicalPoint')" maxlength="5" @input="keyTPoint" :disabled="isCase === 2"></el-input>
              </div>              
            </el-col>
            <!-- 总分 -->
            <el-col :span="8">
              <div class="pointRule-position">
                <span class="totalPoint-style">{{$t('lang.lab_totalPoint1')}}{{ isTotalPoint|valueIsNull }}</span>
              </div>  
              </el-col>
          </el-row>
        </el-form-item>
        <!-- 人气分设置 -->
        <el-form-item prop='scoreRuleList' ref='scoreRuleList' :label="$t('lang.lab_popularitySetting')">
          <el-form :rules="cRules" :model="form" ref="cForm">
            <el-table :data="form.scoreRuleList" border class="table-position">
              <!-- 票数排名最小值 -->
              <el-table-column prop="voteRankMinimum" :label="$t('lang.lab_voteRankMinimum')" align="center">
                <template slot-scope="scope">
                  <template v-if="isCase !== 2">
                    <el-form-item :prop="'scoreRuleList.' + scope.$index + '.voteRankMinimum'" :rules="cRules.voteRankMinimum">
                      <el-input @input="keyVoteRankMinimum(scope.$index)" v-model="scope.row.voteRankMinimum" :placeholder="$t('lang.lab_voteRankMinimum')" maxlength="5" :disabled="scope.$index !== 0"></el-input>
                    </el-form-item>
                  </template>  
                  <template v-else>
                    <span >{{ scope.row.voteRankMinimum|valueIsNullToZero }}</span>
                  </template>
                </template>         
              </el-table-column>
              <!-- 票数排名最大值 -->
              <el-table-column prop="voteRankMaximum" :label="$t('lang.lab_voteRankMaximum')" align="center">
                <template slot-scope="scope">
                  <template v-if="isCase !== 2">
                    <el-form-item :prop="'scoreRuleList.' + scope.$index + '.voteRankMaximum'" :rules="cRules.voteRankMaximum">
                      <el-input @input="keyVoteRankMaximum(scope.$index)" v-model="scope.row.voteRankMaximum" :placeholder="$t('lang.lab_voteRankMaximum')" maxlength="5"></el-input>
                    </el-form-item>
                  </template>  
                  <template v-else>
                    <span >{{ scope.row.voteRankMaximum|valueIsNullToZero }}</span>
                  </template>
                </template>  
              </el-table-column>
              <!-- 得分 -->
              <el-table-column prop="point" :label="$t('lang.lab_votePoint')" align="center">
                <template slot-scope="scope">
                  <template v-if="isCase !== 2">
                    <el-form-item :prop="'scoreRuleList.' + scope.$index + '.point'" :rules="cRules.point">
                      <el-input @input="keyPoint(scope.$index)" v-model="scope.row.point" :placeholder="$t('lang.lab_votePoint')" maxlength="5"></el-input>
                    </el-form-item>
                  </template>  
                  <template v-else>
                    <span >{{ scope.row.point|valueIsNullToZero }}</span>
                  </template>
                </template>  
              </el-table-column>
              <!--操作 -->
              <el-table-column  align="center" v-if="isCase !== 2">
                <template slot="header" slot-scope="scope">
                  <el-button @click="addOption(scope.row)" :disabled="isCase === 2">{{$t('lang.lab_addSetting')}}</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button v-if="scope.$index !== 0 || form.scoreRuleList.length >1"  class="orange" @click="deleteOne(scope.$index)" :disabled="isCase === 2">{{$t('lang.btn_delete')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </el-form-item>
        <!-- 人气奖设置 -->
        <el-row>
          <!-- 人气奖设置 -->
          <el-col :span="8">
            <el-form-item prop="popularityCompete" :label="$t('lang.lab_popularityCompete')">
              <el-switch v-model="form.popularityCompete" active-color="#13ce66" inactive-color="#ff4949" @change="changeSwitch"></el-switch>
            </el-form-item>
          </el-col>
          <!-- 人气排名前 -->
          <el-col :span="16">
            <el-form-item prop="popularityNum" :label="$t('lang.lab_popularityNum')" v-if="form.popularityCompete === true">
              <input style="display: none"/>
              <el-input class="input-width30" v-model="form.popularityNum" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_popularityNum1')" maxlength="2" @input="keyPopularityNum" :disabled="isCase === 2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 赛事封面 -->
        <el-form-item prop="imgUrl" ref="imgUrl" :label="$t('lang.lab_competeImg')" v-if="isCase !== 2">
          <el-upload
              :before-upload="beforeAvatarUpload"
              :class="{imgUrlDisabled:imgUrlMax}"
              accept=".jpg,.jpeg,.png" 
              :on-success="handleSuccessImg"
              :on-remove="handleRemoveImg"
              :on-exceed="outlimit"
              :on-error="uploadErr"
              :limit="1"
              name="files"
              :action="require('@/config/enum').actionname"
              list-type="picture-card"
              :file-list="imgUrlList"
            >
              <el-button size="small" type="primary">{{$t('lang.btn_upload')}}</el-button>
              <div class="el-upload__tip" slot="tip">{{$t('lang.tip_upload_img')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="imgUrl2" :label="$t('lang.lab_competeImg')" v-if="isCase === 2">
          <viewer :images="imgUrlArray">
            <img :src="this.form.imgUrl" class="img-style"/>
          </viewer>
        </el-form-item>
        <!-- 赛事介绍长图 -->
        <el-form-item prop="introduceImgUrl" ref="introduceImgUrl" :label="$t('lang.lab_competeLongPic')" v-if="isCase !== 2">
          <el-upload
              :class="{introduceDisabled:introduceMax}"
              accept=".jpg,.jpeg,.png"  
              :before-upload="beforeAvatarUpload"
              :on-success="handleSuccessRule"
              :on-remove="handleRemoveRule"
              :on-exceed="outlimit"
              :on-error="uploadErr"
              :limit="9"
              name="files"
              :action="require('@/config/enum').actionname"
              list-type="picture-card"
              :file-list="introduceList"
            >
              <el-button size="small" type="primary">{{$t('lang.btn_upload')}}</el-button>
              <div class="el-upload__tip" slot="tip">{{$t('lang.tip_upload1')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="ruleUrlList2" :label="$t('lang.lab_competeLongPic')" v-if="isCase === 2">
          <viewer :images="this.form.introduceImgUrl">
            <img
              v-for="(src,index) in this.form.introduceImgUrl"
              :src="src"
              :key="index"
              class="img-style-mini"
            />
          </viewer>
        </el-form-item>
        <!-- 演示视频 -->
        <el-form-item prop="videoUrl" ref="videoUrl" :label="$t('lang.lab_videoUrl')" v-if="isCase !== 2">
          <el-upload
              accept=".mp4" 
              :on-success="handleSuccessV"
              :on-remove="handleRemoveV"
              :on-exceed="outlimit"
              :on-error="uploadVideoErr"
              :limit="1"
              name="files"
              :action="require('@/config/enum').actionname1"
              :file-list="videoUrlList"
            >
              <el-button size="small" type="primary" :disabled="videoUrlMax">{{$t('lang.btn_upload')}}</el-button>
              <div class="el-upload__tip" slot="tip">{{$t('lang.tip_upload4')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="videoUrl2" :label="$t('lang.lab_videoUrl')" v-if="isCase === 2">
          <video controls playsInline webkit-playsinline class="video-style">
            <source :src="form.videoUrl">
          </video>    
        </el-form-item>
        <!-- 证书背景 -->
        <el-form-item prop="certificateBackgroundUrl" ref="certificateBackgroundUrl" :label="$t('lang.lab_certificateBg')" v-if="isCase !== 2">
          <el-upload
              :before-upload="beforeAvatarUpload"
              :class="{bgUrlDisabled:bgUrlMax}"
              accept=".jpg,.jpeg,.png" 
              :on-success="handleSuccessBg"
              :on-remove="handleRemoveBg"
              :on-exceed="outlimit"
              :on-error="uploadErr"
              :limit="1"
              name="files"
              :action="require('@/config/enum').actionname"
              list-type="picture-card"
              :file-list="backgroundUrlList"
            >
              <el-button size="small" type="primary">{{$t('lang.btn_upload')}}</el-button>
              <div class="el-upload__tip" slot="tip">{{$t('lang.tip_upload1')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="certificateBackgroundUrl2" :label="$t('lang.lab_certificateBg')" v-if="isCase === 2">
          <viewer :images="backgroundUrlArray">
            <img :src="form.certificateBackgroundUrl" class="img-style"/>
          </viewer>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="isCase !== 2">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form','cForm')" :disabled="isTotal === 0">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:onlineList
 *@Description:线上赛管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-27
 */

export default {
  name: '',
  components: {},
  data() {
    // 参赛作品时长限制
    var videoTimeLimitCheck = (rule, value, callback) => {
      console.log('videoTimeLimitCheck', this.form.videoTimeLowLimit, this.form.videoTimeUpLimit)
      if (this.form.videoTimeLowLimit === '' && this.form.videoTimeUpLimit === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_videoTimeLimit1')))
      } else if (this.form.videoTimeLowLimit === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_videoTimeLowLimit')))
      } else if (Number(this.form.videoTimeLowLimit) < 20 || Number(this.form.videoTimeUpLimit) > 120) {
        callback(new Error(this.$i18n.t('lang.warning_videoTime')))
      } else if (this.form.videoTimeUpLimit === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_videoTimeUpLimit')))
      } else if (Number(this.form.videoTimeUpLimit) < Number(this.form.videoTimeLowLimit)) {
        callback(new Error(this.$i18n.t('lang.warning_videoTimeLowUp')))
      } else {
        callback()
      }
    }
    // 报名时间
    var enrollTimeCheck = (rule, value, callback) => {
      console.log('enrollTimeCheck', this.enrollValues)
      if (this.enrollValues === null) {
        callback(new Error(this.$i18n.t('lang.warning_enrollTime')))
      } else if (this.enrollValues.length === 0) {
        callback(new Error(this.$i18n.t('lang.warning_enrollTime')))
      } else {
        callback()
      }
    }
    // 比赛时间
    var raceTimeCheck = (rule, value, callback) => {
      console.log('raceTimeCheck', this.raceValues, this.enrollValues)
      if (this.raceValues === null) {
        callback(new Error(this.$i18n.t('lang.warning_raceTime')))
      } else if (this.raceValues.length === 0) {
        callback(new Error(this.$i18n.t('lang.warning_raceTime')))
      } else if (this.raceValues[1] < this.enrollValues[1]) {
        callback(new Error(this.$i18n.t('lang.warning_endTime')))
      } else if (this.raceValues[0] < this.enrollValues[0]) {
        callback(new Error(this.$i18n.t('lang.warning_startTime1')))
      } else {
        callback()
      }
    }
    // 单人单项费用
    var singleFeeCheck = (rule, value, callback) => {
      console.log('singleFeeCheck')
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_singleFee1')))
      } else {
        callback()
      }
    }
    // 每日可投票数
    var voteNumCheck = (rule, value, callback) => {
      console.log('voteNumCheck', value)
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_voteNum')))
      } else if (Number(value) < 0 || Number(value) > 20) {
        callback(new Error(this.$i18n.t('lang.warning_voteNum')))
      } else {
        callback()
      }
    }
    // 评分规则
    var pointRuleCheck = (rule, value, callback) => {
      console.log('pointRuleCheck')
      if (this.form.popularPoint === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_popularPoint')))
      } else if (Number(this.form.popularPoint) * 10 > 1000) {
        callback(new Error(this.$i18n.t('lang.lab_popularPoint') + this.$i18n.t('lang.warning_pointRange')))
      } else if (this.form.technicalPoint === '') {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_technicalPoint')))
      } else if (Number(this.form.technicalPoint) * 10 > 1000) {
        callback(new Error(this.$i18n.t('lang.lab_technicalPoint') + this.$i18n.t('lang.warning_pointRange')))
      } else {
        callback()
      }
    }
    // 得分
    var pointCheck = (rule, value, callback) => {
      console.log('pointCheck', rule.field, value)
      var str = rule.field.toString()
      str = str.replace('scoreRuleList.', '')
      str = str.replace('.point', '')
      let a = Number(str)
      console.log('str', str, this.form.scoreRuleList[a].point)
      if (value === '' || value === null) {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_votePoint')))
      } else if (Number(value) * 10 > Number(this.form.popularPoint) * 10) {
        callback(new Error(this.$i18n.t('lang.warning_votePoint')))
      } else {
        callback()
      }
    }
    // 票数排名最小
    var voteRankMinimumCheck = (rule, value, callback) => {
      console.log('voteRankMinimumCheck', rule.field, value)
      var str = rule.field.toString()
      str = str.replace('scoreRuleList.', '')
      str = str.replace('.voteRankMinimum', '')
      let a = Number(str)
      console.log('str', str, this.form.scoreRuleList[a].voteRankMinimum)
      if (value === '' || value === null) {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_voteRankMinimum')))
      } else if (value > this.form.enrollLimit) {
        callback(new Error(this.$i18n.t('lang.warning_voteRank')))
      } else if (value < 1) {
        callback(new Error(this.$i18n.t('lang.warning_voteRankLow')))
      } else {
        callback()
      }
    }
    // 年龄限制
    var ageStandardCheck = (rule, value, callback) => {
      if (this.form.ageStandard === null) {
        callback(new Error(this.$i18n.t('lang.warning_ageStandard')))
      } else if (this.form.ageStandard.length === 0) {
        callback(new Error(this.$i18n.t('lang.warning_ageStandard')))
      } else {
        callback()
      }
    }
    // 票数排名最大
    var voteRankMaximumCheck = (rule, value, callback) => {
      console.log('voteRankMaximumCheck', rule.field, value)
      var str = rule.field.toString()
      str = str.replace('scoreRuleList.', '')
      str = str.replace('.voteRankMaximum', '')
      let a = Number(str)
      console.log('str', str, this.form.scoreRuleList[a].voteRankMaximum)
      if (value === '' || value === null) {
        callback(new Error(this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_voteRankMaximum')))
      } else if (value > this.form.enrollLimit) {
        callback(new Error(this.$i18n.t('lang.warning_voteRank')))
      } else if (value < 1) {
        callback(new Error(this.$i18n.t('lang.warning_voteRankLow')))
      } else if (this.form.scoreRuleList[a].voteRankMinimum !== '' && (this.form.scoreRuleList[a].voteRankMinimum > this.form.scoreRuleList[a].voteRankMaximum)) {
        callback(new Error(this.$i18n.t('lang.warning_voteRankMax')))
      } else {
        callback()
      }
    }
    return {
      imgUrlMax: false,
      introduceMax: false,
      bgUrlMax: false,
      videoUrlMax: false,
      isShow: false, // 新增编辑查看dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑查看dialog的title
      isCase: 0, // 当前状态：0新增 1编辑 2查看
      /* 确定按钮可点击 */
      isDisabled_form: 0, // form数据
      isDisabled_enrollValues: 0, // 报名时间
      isDisabled_raceValues: 0, // 比赛时间
      isDisabled_competeList: 0, // 赛事项目
      /* 线下赛列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      states: this.$i18n.t('lang.Offline_states'), // 状态下拉list
      statesNew: this.$i18n.t('lang.Offline_statesNew'), // 新建 状态下拉list
      statesEdit: this.$i18n.t('lang.Offline_statesEdit'), // 编辑 状态下拉list
      state: '', // 筛选-状态
      name: '', // 筛选-赛事名称
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 线下赛列表数据
      /* 记忆筛选项值 */
      state_bak: '', // 备份-状态
      name_bak: '', // 备份-赛事名称
      /* 线下赛详情(新建编辑查看)变量 */
      rules: {
        ageStandard: [{ required: true, validator: ageStandardCheck, trigger: 'change' }],
        name: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_competeName'), trigger: 'blur' }],
        competeStatus: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeStatus'), trigger: 'change' }],
        enrollTime: [{ required: true, validator: enrollTimeCheck, trigger: 'change' }],
        raceTime: [{ required: true, validator: raceTimeCheck, trigger: 'change' }],
        itemAgeId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_itemAgeId'), trigger: 'change' }],
        itemGroupId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_itemGroupId'), trigger: 'change' }],
        enrollLimit: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_enrollLimit'), trigger: 'change' }],
        videoTimeLimit: [{ required: true, validator: videoTimeLimitCheck, trigger: 'blur' }], 
        singleFee: [{ required: true, validator: singleFeeCheck, trigger: 'blur' }],
        voteLimit: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_voteLimit'), trigger: 'change' }],
        voteNum: [{ required: true, validator: voteNumCheck, trigger: 'blur' }],
        pointRule: [{ required: true, validator: pointRuleCheck, trigger: 'blur' }],
        scoreRuleList: [{ required: true, message: this.$i18n.t('lang.pla_pleaseFillin') + this.$i18n.t('lang.lab_popularitySetting'), trigger: 'change' }],
        popularityCompete: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_popularityCompete'), trigger: 'change' }],
        popularityNum: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_popularityNum1'), trigger: 'blur' }],
        imgUrl: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeImg'), trigger: 'change' }],
        imgUrl2: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeImg'), trigger: 'change' }],
        introduceImgUrl: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeLongPic'), trigger: 'change' }],
        ruleUrlList2: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_competeLongPic'), trigger: 'change' }],
        videoUrl: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_videoUrl'), trigger: 'change' }],
        videoUrl2: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_videoUrl'), trigger: 'change' }],
        certificateBackgroundUrl: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_certificateBg'), trigger: 'change' }],
        certificateBackgroundUrl2: [{ required: true, message: this.$i18n.t('lang.pla_pleaseUpload') + this.$i18n.t('lang.lab_certificateBg'), trigger: 'change' }],
      },
      enrollValues: [], // 报名开始结束时间的绑定值
      raceValues: [], // 比赛开结束时间的绑定值
      ageNames: [], // 年龄段下拉list
      groupNames: [], // 组别下拉list
      imgUrlList: [], // 赛事封面上传
      introduceList: [], // 赛事介绍长图上传
      videoUrlList: [], // 演示视频上传
      backgroundUrlList: [], // 证书背景上传
      imgUrlArray: [], // 赛事封面viewer绑定值
      ruleUrlArray: [], // 赛事介绍长图viewer绑定值
      videoUrlArray: [], // 演示视频viewer绑定值
      backgroundUrlArray: [], // 证书背景viewer绑定值
      voteLimits: this.$i18n.t('lang.Online_voteLimits'), // 编辑 状态下拉list
      form: {
        ageStandard: '',
        competeId: '',
        type: 1,
        name: '',
        competeStatus: '',
        competeStatusName: '',
        startTime: '',
        endTime: '',
        enrollStartTime: '',
        enrollEndTime: '',
        enrollLimit: '',
        itemAgeId: '',
        itemGroupId: '',
        videoTimeLowLimit: '',
        videoTimeUpLimit: '',
        singleFee: '',
        voteLimit: '',
        voteNum: '',
        popularPoint: '',
        technicalPoint: '',
        totalPoint: '',
        scoreRuleList: [
          {
            voteRankMinimum: '',
            voteRankMaximum: '',
            point: '',
          }
        ],
        popularityCompete: false,
        popularityNum: '',
        imgUrl: '',
        introduceImgUrl: [],
        videoUrl: '',
        certificateBackgroundUrl: ''
      }, // 详细数据
      cRules: {
        voteRankMinimum: [{ required: true, validator: voteRankMinimumCheck, trigger: 'blur' }],
        voteRankMaximum: [{ required: true, validator: voteRankMaximumCheck, trigger: 'blur' }],
        point: [{ required: true, validator: pointCheck, trigger: 'blur' }],
      },
      /* 日期只能选择今天及之后的 */
      enrollStartTime: '',
      endTime: '',
      pickerOptions0: {
        disabledDate: (time) => {
          return time.getTime() > new Date(this.endTime).getTime() - 2.88e7 - 1 + 8.64e7 
        }
      },
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.enrollStartTime).getTime() - 2.88e7 - 1
        }
      },
    }
  },
  computed: {
    isTotal: function() {
      console.log('isDisabled:', this.isDisabled_form, this.isDisabled_enrollValues, this.isDisabled_raceValues)
      return this.isDisabled_form + this.isDisabled_enrollValues + this.isDisabled_raceValues
    },
    isTotalPoint: function() {
      console.log('isTotalPoint:', this.form.popularPoint, this.form.technicalPoint)
      return (Number(this.form.popularPoint) * 10 + Number(this.form.technicalPoint) * 10) / 10.0
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_form) {
          // 没变
          this.isDisabled_form = 0
        } else {
          // 变了
          this.isDisabled_form = 1
        }
      },
      deep: true,
      immediate: true
    },
    enrollValues: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_enrollValues) {
          // 没变
          this.isDisabled_enrollValues = 0
        } else {
          // 变了
          this.isDisabled_enrollValues = 1
        }
      },
      deep: true,
      immediate: true
    },
    raceValues: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData_raceValues) {
          // 没变
          this.isDisabled_raceValues = 0
        } else {
          // 变了
          this.isDisabled_raceValues = 1
        }
      },
      deep: true,
      immediate: true
    }, 
  },
  methods: {
    beforeAvatarUpload(file) {
       if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
  
       } else {
         this.$message.error(this.$i18n.t('lang.tip_upload1'))
         return false
       }
     },
    // 获取线上赛列表数据
    getData() { 
      this.$get(`/compete/filterOnlineCompete?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取年龄段下拉list
    getAgeList() {
      this.$get('/itemAge/itemAge').then(
        res => {
          if (res && res.code === 200) {
            this.ageNames = res.data.list
            let newValue = {
              id: '',
              ageGroupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_itemAgeId')
            }
            this.ageNames.unshift(newValue)  
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取组别下拉list
    getGroupList() { 
      this.$get('/itemGroup/itemGroup').then(
        res => {
          if (res && res.code === 200) {
            this.groupNames = res.data.list
            let newValue = {
              id: '',
              groupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_itemGroupId')
            }
            this.groupNames.unshift(newValue)     
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag, isSearch) {
      if (flag) {
        this.pageNum = 1
      }
      if (isSearch) {
        // 记忆筛选项值
        this.state_bak = this.state
        this.name_bak = this.name
      } else { 
        // 筛选项正确显示
        this.state = this.state_bak
        this.name = this.name_bak
      }
      this.$get(`/compete/filterOnlineCompete?competeStatus=${this.state}&name=${this.name}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 重置
    onClear() {
      this.name = ''
      this.state = ''
      this.name_bak = ''
      this.state_bak = ''
      this.pageNum = 1
      this.sortName = ''
      this.sortFieldName = ''
      this.getData()
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.imgUrlMax = false
      this.introduceMax = false
      this.bgUrlMax = false
      this.videoUrlMax = false
      this.isCase = 0
      this.form.ageStandard = ''
      this.form.competeId = ''
      this.form.type = 1
      this.form.name = ''
      this.form.competeStatus = ''
      this.form.competeStatusName = ''
      this.form.startTime = ''
      this.form.endTime = ''
      this.form.enrollStartTime = ''
      this.form.enrollEndTime = ''
      this.endTime = ''
      this.enrollStartTime = ''
      this.form.enrollLimit = ''
      this.form.itemAgeId = ''
      this.form.itemGroupId = ''
      this.form.videoTimeLowLimit = ''
      this.form.videoTimeUpLimit = ''
      this.form.singleFee = ''
      this.form.voteLimit = ''
      this.form.voteNum = ''
      this.form.popularPoint = ''
      this.form.technicalPoint = ''
      this.form.totalPoint = ''
      this.form.scoreRuleList = [ 
        {
          voteRankMinimum: '',
          voteRankMaximum: '',
          point: '',
        }
      ]
      this.form.popularityCompete = false
      this.form.popularityNum = ''
      this.form.imgUrl = ''
      this.form.introduceImgUrl = []
      this.form.videoUrl = ''
      this.form.certificateBackgroundUrl = ''
      this.enrollValues = []
      this.raceValues = []
      this.imgUrlList = []
      this.introduceList = []
      this.videoUrlList = []
      this.backgroundUrlList = []
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].competeId)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      console.log('onDelete', this.multipleSelection, array)
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/compete/Onlinecompete/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.isCase = 1
      this.form.ageStandard = data.ageStandard
      this.form.competeId = data.competeId
      this.form.type = data.type      
      this.form.name = data.name
      this.form.competeStatusName = data.competeStatusName
      this.form.competeStatus = data.competeStatus
      this.form.startTime = data.startTime
      this.form.endTime = data.endTime
      this.form.enrollStartTime = data.enrollStartTime
      this.form.enrollEndTime = data.enrollEndTime
      this.endTime = this.onPickTime(data.endTime)
      this.enrollStartTime = this.onPickTime(data.enrollStartTime)
      this.form.enrollLimit = data.enrollLimit
      this.form.itemAgeId = data.itemAgeId
      this.form.itemGroupId = data.itemGroupId
      this.form.videoTimeLowLimit = data.videoTimeLowLimit
      this.form.videoTimeUpLimit = data.videoTimeUpLimit
      this.form.singleFee = data.singleFee
      this.form.voteLimit = data.voteLimit
      this.form.voteNum = data.voteNum
      this.form.popularPoint = data.popularPoint
      this.form.technicalPoint = data.technicalPoint
      this.form.totalPoint = data.totalPoint
      this.form.scoreRuleList = []
      for (let index = 0; index < data.scoreRuleList.length; index++) {
        let str = {
          voteRankMinimum: data.scoreRuleList[index].voteRankMinimum,
          voteRankMaximum: data.scoreRuleList[index].voteRankMaximum,
          point: data.scoreRuleList[index].point,
        }
        this.form.scoreRuleList.push(str)
      }
      this.form.popularityCompete = data.popularityCompete
      this.form.popularityNum = data.popularityNum
      this.form.imgUrl = data.imgUrl
      if (this.form.imgUrl !== '') {
        this.imgUrlMax = true
      }
      this.form.introduceImgUrl = data.introduceImgUrl
      if (this.form.introduceImgUrl.length === 9) {
        this.introduceMax = true
      }
      this.form.videoUrl = data.videoUrl
      if (this.form.videoUrl !== '') {
        this.videoUrlMax = true
      }
      this.form.certificateBackgroundUrl = data.certificateBackgroundUrl
      if (this.form.certificateBackgroundUrl !== '') {
        this.bgUrlMax = true
      }
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData_form = JSON.stringify(this.form)
      this.changeData()
      this.isShow = true
    },
    // 查看
    onDetail(data) {
      console.log('onDetail', data)
      this.isTitle = this.$i18n.t('lang.btn_detail')
      this.isCase = 2
      this.form.ageStandard = data.ageStandard 
      this.form.competeId = data.competeId
      this.form.type = data.type      
      this.form.name = data.name
      this.form.competeStatusName = data.competeStatusName
      this.form.competeStatus = data.competeStatus
      this.form.startTime = data.startTime
      this.form.endTime = data.endTime
      this.form.enrollStartTime = data.enrollStartTime
      this.form.enrollEndTime = data.enrollEndTime
      this.form.enrollLimit = data.enrollLimit
      this.endTime = data.endTime
      this.enrollStartTime = data.enrollStartTime
      this.form.itemAgeId = data.itemAgeId
      this.form.itemGroupId = data.itemGroupId
      this.form.videoTimeLowLimit = data.videoTimeLowLimit
      this.form.videoTimeUpLimit = data.videoTimeUpLimit
      this.form.singleFee = data.singleFee
      this.form.voteLimit = data.voteLimit
      this.form.voteNum = data.voteNum
      this.form.popularPoint = data.popularPoint
      this.form.technicalPoint = data.technicalPoint
      this.form.totalPoint = data.totalPoint
      this.form.scoreRuleList = []
      for (let index = 0; index < data.scoreRuleList.length; index++) {
        let str = {
          voteRankMinimum: data.scoreRuleList[index].voteRankMinimum,
          voteRankMaximum: data.scoreRuleList[index].voteRankMaximum,
          point: data.scoreRuleList[index].point,
        }
        this.form.scoreRuleList.push(str)
      }
      this.form.popularityCompete = data.popularityCompete
      this.form.popularityNum = data.popularityNum
      this.form.imgUrl = data.imgUrl
      this.form.introduceImgUrl = data.introduceImgUrl
      this.form.videoUrl = data.videoUrl
      this.form.certificateBackgroundUrl = data.certificateBackgroundUrl
      this.changeData()
      this.isShow = true
    },
    // 数据转换
    changeData() {
      // 转换报名时间
      this.enrollValues = []
      if (this.form.enrollStartTime && this.form.enrollStartTime !== null && this.form.enrollEndTime && this.form.enrollEndTime !== null) {
        this.enrollValues[0] = this.form.enrollStartTime 
        this.enrollValues[1] = this.form.enrollEndTime 
        this.$set(this.enrollValues, 0, this.form.enrollStartTime) 
        this.$set(this.enrollValues, 1, this.form.enrollEndTime)               
      }
      this.saveData_enrollValues = JSON.stringify(this.enrollValues)
      // 转换比赛时间
      this.raceValues = []
      if (this.form.startTime && this.form.startTime !== null && this.form.endTime && this.form.endTime !== null) {
        this.raceValues[0] = this.form.startTime  
        this.raceValues[1] = this.form.endTime  
        this.$set(this.raceValues, 0, this.form.startTime) 
        this.$set(this.raceValues, 1, this.form.endTime)               
      }
      this.saveData_raceValues = JSON.stringify(this.raceValues)
      // 转换赛事封面
      this.imgUrlList = []
      if (this.form.imgUrl && this.form.imgUrl !== '') {
        this.imgUrlList.push({
          name: '',
          url: this.form.imgUrl.toString()
        })
        this.imgUrlArray.push(this.form.imgUrl.toString())
      }
      // 转换赛事介绍长图
      this.introduceList = []
      if (this.form.introduceImgUrl && this.form.introduceImgUrl !== null) {
        for (let index = 0; index < this.form.introduceImgUrl.length; index++) {
          let temp = this.form.introduceImgUrl[index]
          this.introduceList.push({
            name: '',
            url: temp.toString()
          })
          this.ruleUrlArray.push(temp.toString())          
        }
      }
      // 转换演示视频
      this.videoUrlList = []
      if (this.form.videoUrl && this.form.videoUrl !== null) {
        this.videoUrlList.push({
          name: this.form.videoUrl.toString().split('/').pop(),
          url: this.form.videoUrl.toString()
        })
        this.videoUrlArray.push(this.form.videoUrl.toString())
      }
      // 转换证书背景
      this.backgroundUrlList = []
      if (this.form.videoUrl && this.form.certificateBackgroundUrl !== null) {
        this.backgroundUrlList.push({
          name: '',
          url: this.form.certificateBackgroundUrl.toString()
        })
        this.backgroundUrlArray.push(this.form.certificateBackgroundUrl.toString())
      }
    },
    // 选择报名时间
    onPickEnroll(dateRange) {
      console.log('onPickEnroll', dateRange)
      this.form.enrollStartTime = this.enrollValues[0]
      this.form.enrollEndTime = this.enrollValues[1]
      var date = new Date(this.form.enrollStartTime)
      var Y = date.getFullYear() 
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) 
      var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate()) 
      this.enrollStartTime = Y + '-' + M + '-' + D
      console.log('this.enrollStartTime', this.enrollStartTime)
    },
    // 选择比赛时间
    onPickRace(dateRange) {
      console.log('onPickRace', dateRange)
      this.form.startTime = this.raceValues[0]   
      this.form.endTime = this.raceValues[1]
      var date = new Date(this.form.endTime)
      var Y = date.getFullYear() 
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) 
      var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate()) 
      this.endTime = Y + '-' + M + '-' + D
      console.log('this.endTime', this.endTime)
    },
    // 时间转换
    onPickTime(value) {
      var date = new Date(value)
      var Y = date.getFullYear() 
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) 
      var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate()) 
      return Y + '-' + M + '-' + D
    },
    // 投票限制
    changeSelect(value) {
      console.log('投票限制', value)
      if (value === 1) {
        this.rules.voteNum[0].required = true
        this.$refs.form.validateField('voteNum')
      } else {
        this.rules.voteNum[0].required = false
      }
    },
    // 添加人气分设置
    addOption(data) {
      // 分数填写
      let value = ''
      let length = this.form.scoreRuleList.length
      if (length === 1) {
        if (this.form.scoreRuleList[0].voteRankMaximum !== '') {
          value = this.form.scoreRuleList[0].voteRankMaximum + 1
        }
      } else if (length > 1) {
        if (this.form.scoreRuleList[0].voteRankMaximum !== '') {
          value = this.form.scoreRuleList[length - 1].voteRankMaximum + 1
        }
      } else {
        console.log('scoreRuleList is wrong!')
      }
      // 新填人气分设置显示
      var newValue = {
        voteRankMinimum: value,
        voteRankMaximum: '',
        point: '',
      }
      // 添加新行数
      this.form.scoreRuleList.push(newValue)
    },
    // 删除人气分设置
    deleteOne(index) {
      this.$confirm(
        this.$i18n.t('lang.warning_settingDeleteWarning'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.form.scoreRuleList.splice(index, 1)
          if (index === 0 && this.form.scoreRuleList.length < 1) {
            this.form.scoreRuleList = [{
              voteRankMinimum: '',
              voteRankMaximum: '',
              point: '',
            }]
          }
          this.$refs.cForm.clearValidate() // 移除校验结果
          // this.$refs['cForm'].validate() // 校验
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })
    },
    // 人气奖设置开关
    changeSwitch(value) {
      console.log('人气奖设置开关', value)
      if (value) {
        this.rules.popularityNum[0].required = true
        this.$refs.form.validateField('popularityNum')
      } else {
        this.rules.popularityNum[0].required = false
      }
    },
    // 保存
    toSave(formName, cFormName) {
      console.log('toSave')
      // 变更数据结构
      var array = []
      for (let index = 0; index < this.form.scoreRuleList.length; index++) {
        if (this.form.scoreRuleList[index].voteRankMinimum !== '') {
          let temp = {
            min: this.form.scoreRuleList[index].voteRankMinimum,
            max: this.form.scoreRuleList[index].voteRankMaximum,
            p: this.form.scoreRuleList[index].point,
            diff: this.form.scoreRuleList[index].voteRankMaximum - this.form.scoreRuleList[index].voteRankMinimum,
            line: index
          }
          array.push(temp)
        }
      }
      console.log('toSave 1', array)
      // 人气分设置排序
      for (let i = 0; i < array.length - 1; i++) {
        for (let j = 0; j < array.length - 1 - i; j++) {
          if (array[j].min > array[j + 1].min) {
            let t = array[j]
            array[j] = array[j + 1]
            array[j + 1] = t
          }
        }
      }
      console.log('toSave 2', array)
      // 包含的所有数字
      let allNumber = []
      for (let x = 0; x < array.length; x++) {
        for (let y = 0; y < array[x].diff + 1; y++) {
          allNumber.push(array[x].min + y)
        }
      }
      console.log('allNumber', allNumber)
      // 查重
      let repeatArray = []
      let tempArray = []
      for (let count = 0; count < allNumber.length; count++) {
        if (tempArray.indexOf(allNumber[count]) === -1) {
          tempArray.push(allNumber[count])
        } else {
          repeatArray.push(allNumber[count])
        }
      }
      console.log('repeatArray', repeatArray)
      // 查缺
      let lackArray = []
      console.log('this.form.enrollLimit', this.form.enrollLimit)
      for (let num = 1; num < Number(this.form.enrollLimit) + 1; num++) {
        if (tempArray.indexOf(num) === -1) {
          lackArray.push(num)
        }
      }
      console.log('lackArray', lackArray)

      // 表单验证转换
      if (this.form.voteLimit === 1) {
        this.rules.voteNum[0].required = true
      } else {
        this.rules.voteNum[0].required = false
        this.form.voteNum = ''
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs[cFormName].validate((valid) => {
            if (valid) {
              // 报名时间
              if (this.enrollValues != []) {
                this.form.enrollStartTime = this.enrollValues[0]
                this.form.enrollEndTime = this.enrollValues[1]
              }
              // 比赛时间
              if (this.enrollValues != []) {
                this.form.startTime = this.raceValues[0]   
                this.form.endTime = this.raceValues[1]
              }
              // 人气排名前
              if (this.form.popularityCompete === false) {
                this.form.popularityNum = ''
              }
              let params = this.form
              // 得分检查
              if (repeatArray.length === 0 && lackArray.length === 0) {
                let pointFlag = -1
                for (let index = 0; index < array.length; index++) {
                  if (index + 1 < array.length && Number(array[index].p) * 10 < Number(array[index + 1].p) * 10) {
                    pointFlag = array[index].line
                  }
                }
                console.log('pointFlag', pointFlag)
                if (pointFlag !== -1) {
                  this.$message.error(this.$i18n.t('lang.warning_pointOrder'))
                } else {
                  this.$postJson('/compete/onlineCompete', params).then(
                    res => {
                      this.$message({
                        type: 'success',
                        message: this.$i18n.t('lang.lab_modifySuccess')
                      })
                      if (res && res.code === 200) {
                        this.isShow = false
                        // 更新列表
                        this.onSearch(true, false)
                      } else {
                        this.$message.error(res.message)
                      }
                    },
                    error => {
                      this.$message.error(error)
                    }
                  )            
                }
              } else if (repeatArray.length === 0 && lackArray.length > 0) {
                this.$message.error(this.$i18n.t('lang.warning_pointSettingLack'))
              } else if (repeatArray.length > 0 && lackArray.length === 0) {
                this.$message.error(this.$i18n.t('lang.warning_pointSettingRepeat'))
              } else {
                console.log('else')
                this.$message.error(this.$i18n.t('lang.warning_pointSetting'))
              }
            } else {
              return false
            }
          }) 
        } else {
          if (this.form.scoreRuleList.length > 0) {
            this.$refs[cFormName].validate((valid) => {
              if (valid) {
              } else {
                return false
              }
            }) 
          }
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      if (this.form.scoreRuleList.length > 0) {
        this.$refs.cForm.clearValidate()
      }
      this.$refs.form.clearValidate()
      this.form.ageStandard = ''
      this.form.competeId = ''
      this.form.type = 1
      this.form.name = ''
      this.form.competeStatus = ''
      this.form.competeStatusName = ''
      this.form.startTime = ''
      this.form.endTime = ''
      this.form.enrollStartTime = ''
      this.form.enrollEndTime = ''
      this.endTime = ''
      this.enrollStartTime = ''
      this.form.enrollLimit = ''
      this.form.itemAgeId = ''
      this.form.itemGroupId = ''
      this.form.videoTimeLowLimit = ''
      this.form.videoTimeUpLimit = ''
      this.form.singleFee = ''
      this.form.voteLimit = ''
      this.form.voteNum = ''
      this.form.popularPoint = ''
      this.form.technicalPoint = ''
      this.form.totalPoint = ''
      this.form.scoreRuleList = [ 
        {
          voteRankMinimum: '',
          voteRankMaximum: '',
          point: '',
        }
      ]
      this.form.popularityCompete = false
      this.form.popularityNum = ''
      this.form.imgUrl = ''
      this.form.introduceImgUrl = []
      this.form.videoUrl = ''
      this.form.certificateBackgroundUrl = ''
      this.enrollValues = []
      this.raceValues = []
      this.imgUrlList = []
      this.introduceList = []
      this.videoUrlList = []
      this.backgroundUrlList = []
    },
    // 进入选手列表页面
    linkPlayer(data) {
      console.log('选手列表', data)
      this.$router.push({ name: 'netPlayers', query: { competeId: data.competeId, competeName: data.name } })
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 监听关闭'新建编辑查看'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      if (this.form.scoreRuleList.length > 0) {
        this.$refs.cForm.clearValidate()
      }
      this.form.id = ''
      this.form.type = 1
      this.form.name = ''
      this.form.competeStatus = ''
      this.form.competeStatusName = ''
      this.form.startTime = ''
      this.form.endTime = ''
      this.form.enrollStartTime = ''
      this.form.enrollEndTime = ''
      this.endTime = ''
      this.enrollStartTime = ''
      this.form.enrollLimit = ''
      this.form.itemAgeId = ''
      this.form.itemGroupId = ''
      this.form.videoTimeLowLimit = ''
      this.form.videoTimeUpLimit = ''
      this.form.singleFee = ''
      this.form.voteLimit = ''
      this.form.voteNum = ''
      this.form.popularPoint = ''
      this.form.technicalPoint = ''
      this.form.totalPoint = ''
      this.form.scoreRuleList = [ 
        {
          voteRankMinimum: '',
          voteRankMaximum: '',
          point: '',
        }
      ]
      this.form.popularityCompete = false
      this.form.popularityNum = ''
      this.form.imgUrl = ''
      this.form.introduceImgUrl = []
      this.form.videoUrl = ''
      this.form.certificateBackgroundUrl = ''
      this.enrollValues = []
      this.raceValues = []
      this.imgUrlList = []
      this.introduceList = []
      this.videoUrlList = []
      this.backgroundUrlList = []
    },
    // 翻页 
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.warning_uploadLimit'))
    },
    // 赛事封面上传
    handleSuccessImg(response, file, fileList) {
      console.log('Upload Success Img!', file, fileList)
      this.imgUrlMax = true
      this.form.imgUrl = file.response.data[0]
      this.imgUrlList[0] = file.response.data[0]
      this.$refs.imgUrl.clearValidate()
    },
    // 赛事封面删除
    handleRemoveImg(file, fileList) {
      console.log('handleRemoveImge!', file, fileList)
      this.imgUrlList = fileList
      this.form.imgUrl = ''
      this.imgUrlMax = false
    },
    // 赛事介绍长图上传
    handleSuccessRule(response, file, fileList) {
      console.log('Upload Success Rule!', file, fileList)
      if (fileList.length === 9) {
        this.introduceMax = true
      } else {
        this.introduceMax = false
      }
      this.introduceList = fileList
      if (this.introduceList.length > 0) {
        this.form.introduceImgUrl = []
        for (let index = 0; index < this.introduceList.length; index++) {
          this.form.introduceImgUrl.push(this.introduceList[index].response.data[0])
        }
        this.$refs.introduceImgUrl.clearValidate()
      }
    },
    // 赛事介绍长图删除
    handleRemoveRule(file, fileList) {
      console.log('handleRemoveRule!', file, fileList)
      this.introduceList = fileList
      if (this.introduceList.length > 0) {
        this.form.introduceImgUrl = []
        for (let index = 0; index < this.introduceList.length; index++) {
          this.form.introduceImgUrl.push(this.introduceList[index].response.data[0])
        }
      } else {
        this.form.introduceImgUrl = []
      }
      this.introduceMax = false
      console.log(this.form.introduceImgUrl)
    },
    // 演示视频上传
    handleSuccessV(response, file, fileList) {
      console.log('Upload Success V!', file, fileList)
      if (file.raw.type !== 'video/mp4') {
        // 格式不正确
        this.videoUrlMax = false
        this.videoUrlList = []
        this.form.videoUrl = ''
        this.$message.error(this.$i18n.t('lang.error_uploadVideoErr'))        
      } else if (file.response === '') {
        // IE、360兼容 超大文件上传返回成功但返回值为空
        this.videoUrlMax = false
        this.videoUrlList = []
        this.form.videoUrl = ''
        this.$message.error(this.$i18n.t('lang.error_uploadErr'))
      } else if (file.response && file.response.code === 200) {
        // 上传成功
        this.videoUrlMax = true
        this.form.videoUrl = file.response.data[0]
        this.videoUrlList[0] = file.response.data[0]
        this.$refs.videoUrl.clearValidate()      
      } else if (file.response && file.response.code !== 200) {
        // 上传异常
        this.videoUrlMax = false
        this.videoUrlList = []
        this.form.videoUrl = ''
        this.$message.error(file.response.message)     
      } else {
        // else
        console.log('handleSuccessV else')
        this.videoUrlMax = false
        this.videoUrlList = []
        this.form.videoUrl = ''   
        this.$refs.videoUrl.clearValidate()      
      }
    },
    // 演示视频删除
    handleRemoveV(file, fileList) {
      console.log('handleRemoveV!')
      this.videoUrlList = fileList
      this.form.videoUrl = ''
      this.videoUrlMax = false
    },
    // 证书背景上传
    handleSuccessBg(response, file, fileList) {
      console.log('Upload Success Bg!', file, fileList)
      this.bgUrlMax = true
      this.form.certificateBackgroundUrl = file.response.data[0]
      this.backgroundUrlList[0] = file.response.data[0]
      this.$refs.certificateBackgroundUrl.clearValidate()
    },
    // 证书背景删除
    handleRemoveBg(file, fileList) {
      console.log('handleRemoveBg!')
      this.backgroundUrlList = fileList
      this.form.certificateBackgroundUrl = ''
      this.bgUrlMax = false
    },
    // 上传文件的断网
    uploadErr(err, file, fileList) {
      console.log('uploadErr', err, file, fileList)
      if (file.status === 'fail') {
        this.$message.error(this.$i18n.t('lang.error_uploadErr'))
      }
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
          loading.close()
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }, 500)
      }
    },
    // 上传演示视频失败
    uploadVideoErr(err, file, fileList) {
      console.log('uploadVideoErr', err, file, fileList)
      if (file.status === 'fail') {
        this.$message.error(this.$i18n.t('lang.error_uploadErr'))
        this.videoUrlMax = false
        this.videoUrlList = []
        this.form.videoUrl = ''
      }
      if (!navigator.onLine || window.navigator.onLine === false) {
        const loading = this.$loading()
        setTimeout(() => {
          loading.close()
          this.$message.error(this.$i18n.t('lang.warning_network'))
        }, 500)
      }
    },
    // 报名上限
    keyEnrollLimit() {
      // 仅保留数字
      this.form.enrollLimit = this.form.enrollLimit.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.enrollLimit.indexOf('.') < 0 && this.form.enrollLimit !== '') { 
        this.form.enrollLimit = parseFloat(this.form.enrollLimit)
      }
    },
    // 参赛作品时长下限 输入限制
    keyTimeLow() {
      // 仅保留数字
      this.form.videoTimeLowLimit = this.form.videoTimeLowLimit.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.videoTimeLowLimit.indexOf('.') < 0 && this.form.videoTimeLowLimit !== '') { 
        this.form.videoTimeLowLimit = parseFloat(this.form.videoTimeLowLimit)
      }
    },
    // 参赛作品时长上限 输入限制
    keyTimeHigh() {
      // 仅保留数字
      this.form.videoTimeUpLimit = this.form.videoTimeUpLimit.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.videoTimeUpLimit.indexOf('.') < 0 && this.form.videoTimeUpLimit !== '') { 
        this.form.videoTimeUpLimit = parseFloat(this.form.videoTimeUpLimit)
      }
    },
    // 单人单项费用 输入限制
    keySingleFee() {
      // 仅保留数字和"."
      this.form.singleFee = this.form.singleFee.replace(/[^\d.]/g, '') 
      // 两个连续的"."仅保留第一个"."
      this.form.singleFee = this.form.singleFee.replace(/\.{2,}/g, '.')
      // 去除其他"."
      this.form.singleFee = this.form.singleFee.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      // 限制只能输入两个小数
      this.form.singleFee = this.form.singleFee.replace(/^(\d+)\.(\d\d).*$/, '$1.$2') 
      // 首位是0的话去掉
      if (this.form.singleFee.indexOf('.') < 0 && this.form.singleFee !== '') { 
        this.form.singleFee = parseFloat(this.form.singleFee)
      }
    },
    // 每日可投票数 输入限制
    keyLimitNum() {
      // 仅保留数字
      this.form.voteNum = this.form.voteNum.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.voteNum.indexOf('.') < 0 && this.form.voteNum !== '') { 
        this.form.voteNum = parseFloat(this.form.voteNum)
      }
    },
    // 人气分 输入限制
    keyPPoint() {
      // 仅保留数字和"."
      this.form.popularPoint = this.form.popularPoint.replace(/[^\d.]/g, '') 
      // 两个连续的"."仅保留第一个"."
      this.form.popularPoint = this.form.popularPoint.replace(/\.{2,}/g, '.')
      // 去除其他"."
      this.form.popularPoint = this.form.popularPoint.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      // 限制只能输入一个小数
      this.form.popularPoint = this.form.popularPoint.replace(/^(\d+)\.(\d).*$/, '$1.$2') 
      // 首位是0的话去掉
      if (this.form.popularPoint.indexOf('.') < 0 && this.form.popularPoint !== '') { 
        this.form.popularPoint = parseFloat(this.form.popularPoint)
      }
    },
    // 专家分 输入限制
    keyTPoint() {
      // 仅保留数字和"."
      this.form.technicalPoint = this.form.technicalPoint.replace(/[^\d.]/g, '') 
      // 两个连续的"."仅保留第一个"."
      this.form.technicalPoint = this.form.technicalPoint.replace(/\.{2,}/g, '.')
      // 去除其他"."
      this.form.technicalPoint = this.form.technicalPoint.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      // 限制只能输入一个小数
      this.form.technicalPoint = this.form.technicalPoint.replace(/^(\d+)\.(\d).*$/, '$1.$2') 
      // 首位是0的话去掉
      if (this.form.technicalPoint.indexOf('.') < 0 && this.form.technicalPoint !== '') { 
        this.form.technicalPoint = parseFloat(this.form.technicalPoint)
      }
    },
    // 票数排名最小值 输入限制
    keyVoteRankMinimum(min) {
      console.log('keyVoteRankMinimum', min, this.form.scoreRuleList[min].voteRankMinimum)
      // 仅保留数字
      this.form.scoreRuleList[min].voteRankMinimum = this.form.scoreRuleList[min].voteRankMinimum.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      if (this.form.scoreRuleList[min].voteRankMinimum.indexOf('.') < 0 && this.form.scoreRuleList[min].voteRankMinimum != '') {
        this.form.scoreRuleList[min].voteRankMinimum = parseFloat(this.form.scoreRuleList[min].voteRankMinimum)
      }
    },
    // 票数排名最大值 输入限制
    keyVoteRankMaximum(max) {
      console.log('keyVoteRankMinimum', max, this.form.scoreRuleList[max].voteRankMaximum)
      // 仅保留数字
      this.form.scoreRuleList[max].voteRankMaximum = this.form.scoreRuleList[max].voteRankMaximum.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      if (this.form.scoreRuleList[max].voteRankMaximum.indexOf('.') < 0 && this.form.scoreRuleList[max].voteRankMaximum != '') {
        this.form.scoreRuleList[max].voteRankMaximum = parseFloat(this.form.scoreRuleList[max].voteRankMaximum)
      }
      if (this.form.scoreRuleList[max].voteRankMaximum !== '' && this.form.scoreRuleList[max].voteRankMinimum <= this.form.scoreRuleList[max].voteRankMaximum) {
        if (max + 1 < this.form.scoreRuleList.length) {
          this.form.scoreRuleList[max + 1].voteRankMinimum = this.form.scoreRuleList[max].voteRankMaximum + 1
        }
      }
    },
    // 得分 输入限制
    keyPoint(p) {
      // 当前输入框
      console.log('keyPoint', p, this.form.scoreRuleList[p].point)
      // 仅保留数字和"."
      this.form.scoreRuleList[p].point = this.form.scoreRuleList[p].point.replace(/[^\d.]/g, '') 
      // 两个连续的"."仅保留第一个"."
      this.form.scoreRuleList[p].point = this.form.scoreRuleList[p].point.replace(/\.{2,}/g, '.')
      // 去除其他"."
      this.form.scoreRuleList[p].point = this.form.scoreRuleList[p].point.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
      // 限制只能输入一个小数
      this.form.scoreRuleList[p].point = this.form.scoreRuleList[p].point.replace(/^(\d+)\.(\d).*$/, '$1.$2') 
      // 首位是0的话去掉
      if (this.form.scoreRuleList[p].point.indexOf('.') < 0 && this.form.scoreRuleList[p].point !== '') { 
        this.form.scoreRuleList[p].point = parseFloat(this.form.scoreRuleList[p].point)
      }
    },
    // 人气排名前 输入限制
    keyPopularityNum() {
      // 仅保留数字
      this.form.popularityNum = this.form.popularityNum.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.popularityNum.indexOf('.') < 0 && this.form.popularityNum !== '') { 
        this.form.popularityNum = parseFloat(this.form.popularityNum)
      }
    },
  },
  created() {
    this.getData()
    this.getAgeList()
    this.getGroupList()
  },
  mounted() {}
}
</script>

<style lang='scss'>
.onlineList{
  .center-style{
    width: 100%;
    text-align: center;
    margin: 0 auto;
  }
  .img-style {
    width: 200px;
    height: 150px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }
  .img-style-mini {
    width: 100px;
    height: 75px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }
  .video-style{
    width: 200px;
    height: 150px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;    
  }
  .margin-r20 {
    margin-right: 20px;
  }
  .margin-t10 {
    margin-top: 10px;
  }
  .table-position{
    .el-table__header {
      width: 100% !important;
    }
    .el-table__empty-block {
      width: 100% !important;
    }
    .el-table__body {
      width: 100% !important;
    }
  }
  .deleteBtn-style{
    float: right;
    vertical-align: middle;
  }
  .dialog-style{
    .el-dialog .el-form .el-form-item {
      margin-right: 20px;
    }    
  }
  .imgUrlDisabled{
    .el-upload--picture-card {
      display: none!important;
    }
    .el-button--small {
      display: none!important;
    }
  }
  .introduceDisabled{
    .el-upload--picture-card {
      display: none!important;
    }
    .el-button--small {
      display: none!important;
    }
  }
  .bgUrlDisabled{
    .el-upload--picture-card {
      display: none!important;
    }
    .el-button--small {
      display: none!important;
    }
  }
  .pointRule-position{
    display:flex;
    .popularPoint-style{
      width:80px;
      margin-left:10px;
    }
    .technicalPoint-style{
      width:80px;
      margin-left:10px;
    }
    .totalPoint-style{
      width:80px;
      margin-left:10px;
    }
  }
  .input-width30{
    width: 200px;
  }
}
</style>
